import React, { useEffect, useState } from 'react';
import {
  SettingSystemUserButton,
  SettingSystemUserHeader,
  SystemUserContainer,
} from '../system-users/systemUserStyled';
import Heading from '../../../components/typography';
import Table from '../../../components/table';
import { EmailLogHeader } from '../../../constants/table-headers/emailLogHeader';
import { InvitationBlockData, TableParamsType } from '../../../types/common';
import InitialValuesForm from '../../../constants/initialValues';
import Filter from '../../../components/filter';
import FormSelect from '../../../components/dropdown/formSelect';
import { EmailStatusOptions, YesNoOptions } from '../../../constants/common';
import { ResetFilterWrapper } from '../../../constants/style/common.styled';
import { SwitchContainer } from './email.styled';
import {
  useAdvanceBoolean,
  useGetCompanyNotificationConfig,
  useGetEmailNotificationList,
  useGetTablePreferences,
  usePostTablePreferences,
  useWealthlaneNotificationApi,
} from '../../../hooks';
import { toast } from 'react-toastify';
import ToastComponent from '../../../components/toast';
import {
  CompanyNotificationConfigurationService,
  EmailResendService,
} from '../../../services/wealthlane-notification-services';
import { useQueryClient } from 'react-query';
import CheckPermissions from '../../../utils/permission/checkPermission';
import Search from '../../../components/search/search';
import { FilterBlock } from '../../participants/participant.styled';
import _ from 'lodash';
import {
  DynamicTable,
  withDynamicTableContext,
  useDynamicTable,
  useTableSchemaLoader,
} from '@wealthlane/table-builder';
import Spinners from '../../../components/spinner';
import { axiosInstance } from '../../../services/apiInterceptor';
import AlertPopup from '../../../components/alert-popup';

const EmailLogs = () => {
  const { handleRequest } = useWealthlaneNotificationApi();
  // const [tableInfo, setTableInfo] = useState<TableParamsType>(InitialValuesForm.tableParams);
  const [open, setOpen] = useState(false);
  const { tableInfo, setTableInfo } = useDynamicTable();
  const [headerList, setHeaderList] = useState<string[]>([]);

  useEffect(() => {
    setTableInfo(InitialValuesForm.tableParams);
  }, []);
  const { data, status } = useGetEmailNotificationList(handleRequest, tableInfo);
  const { data: notificationStatus } = useGetCompanyNotificationConfig(handleRequest);
  const [toggle, setToggle] = useState<boolean>(false);
  const [searchQuery, setSearchQuery] = useState('');
  const [checkedValues, setCheckedValues] = useState<any>([]);
  const [checkedItems, setCheckedItems] = useState<any>([]);
  const [isResendLoading, setIsResendLoading] = useState<boolean>(false);
  const [selectedTableData, setSelectedTableData] = useState<any>([]);
  const {
    value: isConfirmResendOpen,
    setFalse: closeConfirmResendModal,
    setTrue: openConfirmBulkResendModal,
    customValue: resendCustomValue,
    setCustomValue: setResendCustomValue,
  } = useAdvanceBoolean(false);

  const queryClient = useQueryClient();
  const { schemaData, isTableSchemaLoading } = useTableSchemaLoader({
    identifier: 'EMAIL_LOGS_TABLE',
    baseUrl: process.env.REACT_APP_WEALTHLANE_API_ENDPOINT,
  });
  const { data: tablePreferences } = useGetTablePreferences(handleRequest, 'Email Log');

  useEffect(() => {
    tablePreferences != null && setHeaderList([...tablePreferences]);
  }, [tablePreferences]);

  const { mutate: postTablePreference, isLoading: tablePrefLoading } =
    usePostTablePreferences(handleRequest);

  const handleSavePreference = (value: string[]): void => {
    const prefPayload = {
      tableName: 'Email Log',
      preferences: value,
    };
    postTablePreference(prefPayload);
  };
  const CompanyNotificationConfig = (data: boolean) => {
    const payload = { isEmailEnableToParticipant: data };
    handleRequest(
      CompanyNotificationConfigurationService.postApiNotificationApiAppCompanyNotificationConfigurationToggleEmailToParticipant(
        payload
      )
        .then((res: any) => {
          if (res?.success) {
            toast.success(<ToastComponent label='Success' message='Email service saved.' />);
            queryClient.invalidateQueries('getCompanyNotificationConfig');
          }
        })
        .catch((error: any) => {
          toast.error(
            <ToastComponent
              label='Error'
              message={'Cannot change notification settings for sandbox tenant'}
            />,
            {
              autoClose: 30000,
            }
          );
          setToggle(false);
        })
        .finally(() => {})
    );
  };

  const handleChecked = (values: string[]): void => {
    setCheckedValues(values);
  };

  const onBulkResendClick = (values: Record<string, any>): void => {
    handleBulkResend(checkedValues);
  };

  const handleBulkResend = (values: string[]): void => {
    setIsResendLoading(true);
    handleRequest(
      EmailResendService.postApiNotificationApiAppEmailResendResendEmails({
        notificationIds: values,
      })
    )
      .then((response: any) => {
        if (response != null) {
          void queryClient.resetQueries('getEmailNotificationList');
          closeConfirmResendModal();
          toast.success(<ToastComponent label='Success' message='Email Resending In Progress.' />);
          setCheckedValues([]);
          setIsResendLoading(false);
        }
      })
      .catch((error) => {
        console.log(error);
      })
      .finally(() => {
        closeConfirmResendModal();
        setIsResendLoading(false);
      });
  };

  const renderRightToolbarButton = () => {
    return (
      <div className='flex gap-x-4 justify-end toggle-size' id='toolbarActions'>
        <CheckPermissions type={'Edit'}>
          <SwitchContainer id='emailToggleContainer'>
            <div className='flex gap-2' id='toggleWrapper'>
              <label className='switch' id='switchLabel'>
                <input
                  type='checkbox'
                  id='emailEnableToggle'
                  onChange={(e: any) => {
                    setToggle(!notificationStatus?.isEmailEnableToParticipant);
                    CompanyNotificationConfig(e.target.checked);
                  }}
                  checked={toggle || notificationStatus?.isEmailEnableToParticipant}
                />
                <span className='slider round' id='sliderIndicator'></span>
              </label>
              <Heading title={'Enable/Disable Email'} variant='body' id='toggleLabel' />
            </div>
          </SwitchContainer>
        </CheckPermissions>
      </div>
    );
  };

  const tableHeaderList = EmailLogHeader({ actions: schemaData?.columns })
    .filter((item) => item.isSubHeader)
    .map((item) => {
      // console.log('item', item);

      return {
        label: item.Header,
        value: item.accessor,
      };
    });

  const emailLogHeader = (): any[] => {
    return EmailLogHeader({ actions: schemaData?.columns }).filter(
      (item) => item.isSubHeader === false || headerList.includes(item.accessor)
    );
  };

  const schema = React.useMemo(
    () => ({
      columns: emailLogHeader(),
      options: schemaData?.options as any,
    }),
    [schemaData]
  );
  const inivitationBlockDatas: InvitationBlockData = {
    buttons: [
      {
        id: 'bulkDeleteButton',
        variant: 'primary',
        title: 'Bulk Resend Email',
        icon: 'delete',
        handleAction: () => openConfirmBulkResendModal(),
      },
    ],
  };

  if (isTableSchemaLoading) return <Spinners containerClassName='h-screen' />;

  return (
    <SystemUserContainer data-page='emailService' id='pageContainer'>
      <div className='flex justify-between items-center' id='pageHeader'>
        <SettingSystemUserHeader id='headerContent'>
          <Heading variant='h3' title='Email Logs' id='pageTitle' />
        </SettingSystemUserHeader>
      </div>

      {/* <FilterBlock>
        <div className='flex flex-col sm:flex-row justify-between gap-4 sm:gap-0'>
          <div className='grid grid-cols-3 sm:grid-cols-6 md:grid-cols-12 w-full gap-1.5'>
            <div className='col-span-3 sm:col-span-3 md:col-span-5'>
              <Search
                placeholder='Search'
                searchValue={searchQuery}
                onSearch={(value: string) => {
                  setSearchQuery(value);
                }}
                setTableInfo={setTableInfo}
                tableInfo={tableInfo}
              />
            </div>
            <div className='col-span-4 md:col-span-4 lg:col-span-3 flex gap-1.5'>
              <Filter setOpen={setOpen} open={open} className='block'>
                <Heading variant='body-xs' title={'Filter By:'} className={'filter-label'} />
                <div className='grid sm:grid-cols-3 gap-x-5'>
                  <FormSelect
                    type='text'
                    name=''
                    placeholder='Email Status'
                    onChange={(value: boolean) => {
                      setTableInfo({ ...tableInfo, emailStatus: value, skipCount: 0 });
                    }}
                    setTableInfo={setTableInfo}
                    tableInfo={tableInfo}
                  />
                </div>
                <div className='col-span-4 md:col-span-4 lg:col-span-3 flex gap-1.5'>
                  <Filter setOpen={setOpen} open={open} className='block'>
                    <Heading variant='body-xs' title={'Filter By:'} className={'filter-label'} />
                    <div className='grid sm:grid-cols-3 gap-x-5'>
                    <FormSelect
                type='text'
                name=''
                placeholder='Email Status'
                onChange={(value: boolean) => {
                  setTableInfo({ ...tableInfo, emailStatus: value, skipCount: 0 });
                }}
                options={EmailStatusOptions}
                values={tableInfo.emailStatus}
                arrValue={tableInfo.emailStatus}
                isFormik={false}
              />
                 
                    </div>
                  </Filter>
                  <div className='col-span-5 lg:col-span-2 items-start gap-x-1'>
                  <ResetFilterWrapper
              onClick={() => {
                setTableInfo({
                  ...InitialValuesForm.tableParams,
                  maxResultCount: 50,
                });
              }}>
                      <span className='material-symbols-outlined'>settings_backup_restore</span>
                      <Heading variant='body-s' title='Reset Filter' />
                    </ResetFilterWrapper>
                  </div>
                </div>
              </div>
              <div className='flex gap-x-4 justify-end toggle-size'>
              <CheckPermissions type={'Edit'}>
          <SwitchContainer>
            <div className='flex gap-2'>
              <label className='switch'>
                <input
                  type='checkbox'
                  onChange={(e: any) => {
                    setToggle(!notificationStatus?.isEmailEnableToParticipant);
                    CompanyNotificationConfig(e.target.checked);
                  }}
                  checked={toggle || notificationStatus?.isEmailEnableToParticipant}
                />
                <span className='slider round'></span>
              </label>
              <Heading title={'Enable/Disable Email'} variant='body' />
            </div>
          </SwitchContainer>
        </CheckPermissions>
              </div>
            </div>
          </div>
          <div className='flex gap-x-4 justify-end toggle-size'>
            <CheckPermissions type={'Edit'}>
              <SwitchContainer>
                <div className='flex gap-2'>
                  <label className='switch'>
                    <input
                      type='checkbox'
                      onChange={(e: any) => {
                        setToggle(!notificationStatus?.isEmailEnableToParticipant);
                        CompanyNotificationConfig(e.target.checked);
                      }}
                      checked={toggle || notificationStatus?.isEmailEnableToParticipant}
                    />
                    <span className='slider round'></span>
                  </label>
                  <Heading title={'Enable/Disable Email'} variant='body' />
                </div>
              </SwitchContainer>
            </CheckPermissions>
          </div>
        </div>
      </FilterBlock> */}

      {/* <div className='flex justify-between'>
      <Search
                    placeholder='Search'
                    searchValue={searchQuery}
                    onSearch={(value: string) => {
                      setSearchQuery(value);
                    }}
                    setTableInfo={setTableInfo}
                    tableInfo={tableInfo}
                  />
        <div className='flex gap-x-4 mb-10'>
          <Filter setOpen={setOpen} open={open} className='block'>
            <Heading variant='body-xs' title={'Filter By:'} className={'filter-label'} />
            <div className='grid sm:grid-cols-3 gap-x-5'>
              <FormSelect
                type='text'
                name=''
                placeholder='Email Status'
                onChange={(value: boolean) => {
                  setTableInfo({ ...tableInfo, emailStatus: value, skipCount: 0 });
                }}
                options={EmailStatusOptions}
                values={tableInfo.emailStatus}
                arrValue={tableInfo.emailStatus}
                isFormik={false}
              />
            </div>
          </Filter>
          <div className='col-span-5 lg:col-span-2 items-start gap-x-1'>
            <ResetFilterWrapper
              onClick={() => {
                setTableInfo({
                  ...InitialValuesForm.tableParams,
                  maxResultCount: 50,
                });
              }}>
              <span className='material-symbols-outlined'>settings_backup_restore</span>
              <Heading variant='body-s' title='Reset Filter' />
            </ResetFilterWrapper>
          </div>
        </div>
    
      </div> */}

      {/* {isConfirmOpen && (
        <AlertPopup
          isShow={isConfirmOpen}
          closeModal={closeConfirmModal}
          modalStatus={modalStatus}
          title={'this Message'}
          handleSubmit={onPrimaryClick}
          // setRemark={setRemark}
          // remark={remark}
          loading={modalLoading}
        />
      )} */}
      <DynamicTable
        schema={schema}
        data={data?.items ?? []}
        totalCounts={data?.totalCount ?? 10}
        loading={status}
        components={{
          renderRightToolbarButton,
        }}
        filteredData={data?.items?.filter((item: any) => item?.status === 'Not Sent')}
        filteredKey={'id'}
        tableColumnList={tableHeaderList}
        selectedColumnList={headerList}
        tablePreferenceLoading={tablePrefLoading}
        handleColumnSave={handleSavePreference}
        onChecked={handleChecked}
        checkedValues={checkedValues}
        setSelectedTableData={setSelectedTableData}
        selectedTableData={selectedTableData}
        checkedItems={checkedItems}
        setCheckedItems={setCheckedItems}
        inivitationBlockDatas={inivitationBlockDatas}
        showCheckBox={true}
        id='emailLogsTable'
      />
      {isConfirmResendOpen && (
        <AlertPopup
          id='bulkResendModal'
          isShow={isConfirmResendOpen}
          handleSubmit={onBulkResendClick}
          closeModal={closeConfirmResendModal}
          customTitle={'Are you sure you want to resend the selected emails?'}
          loading={isResendLoading}
        />
      )}
      {/* <Table
        columns={EmailLogHeader}
        data={data?.items ?? []}
        loading={status}
        showPagination
        totalCounts={data?.totalCount ?? 10}
        tableInfo={tableInfo}
        setTableInfo={setTableInfo}
      /> */}
    </SystemUserContainer>
  );
};

export default withDynamicTableContext(EmailLogs, false, axiosInstance);
